import api from "./api"

const configServiceAPI = {
    getGlobalConfigurationData: async (configType) => {
        return api.get(
            `api/v1/config/config-type/${configType}`,
            "PLATFORM_SERVICE"
        )
    },
}

export default configServiceAPI
